<template>
  <Modal
    no-cancel
    :tracking="{
      action: 'checkout',
      topicKey: 'scratchcard_sold_out',
    }"
    @confirm="emit('confirm')"
  >
    <template #headline>
      {{ $t('scratchcard.soldoutmodal.headline') }}
    </template>

    <template #confirm>
      {{ $t('scratchcard.soldoutmodal.confirm') }}
    </template>

    <div class="flex flex-col gap-200 items-center">
      <p>{{ $t('scratchcard.soldoutmodal.message') }}</p>
      <Illustration name="sold-out" />
    </div>
  </Modal>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'confirm'): void
}>()
</script>
